import { render, staticRenderFns } from "./del-modal.vue?vue&type=template&id=2957ec54"
import script from "./del-modal.vue?vue&type=script&lang=js"
export * from "./del-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports